import { render, staticRenderFns } from "./SpaceTreeShowCopy.vue?vue&type=template&id=6ce132c9&scoped=true&"
import script from "./SpaceTreeShowCopy.vue?vue&type=script&lang=js&"
export * from "./SpaceTreeShowCopy.vue?vue&type=script&lang=js&"
import style0 from "./SpaceTreeShowCopy.vue?vue&type=style&index=0&id=6ce132c9&prod&lang=css&"
import style1 from "./SpaceTreeShowCopy.vue?vue&type=style&index=1&id=6ce132c9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce132c9",
  null
  
)

export default component.exports